<template>
    <FilterBuilderRow
        v-if="active"
        v-bind="rowProps()"
        @remove="remove"
    >
        <template #tooltip>
            <slot name="tooltip">{{ tooltipText }}</slot>
        </template>

        <!--
            IMPORTANTE: popper-append-to-body=false mantém o dropdown dentro do popover.
            Sem isso, clicar numa opção conta como "clique fora" e fecha o FilterBuilder.
        -->
        <el-select
            v-model="draft"
            :disabled="disabled"
            size="small"
            style="width: 100%"
            :multiple="multiple"
            :collapse-tags="multiple"
            :filterable="filterable"
            :clearable="clearable"
            :placeholder="placeholder"
            :popper-append-to-body="false"
        >
            <!-- Opções personalizáveis: passe seus próprios <el-option> no slot -->
            <slot>
                <el-option
                    v-for="opt in options"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                />
            </slot>
        </el-select>
    </FilterBuilderRow>
</template>

<script>
    import { Select, Option } from 'element-ui';
    import FilterBuilderRow from './FilterBuilderRow.vue';
    import filterBuilderItem from './filterBuilderItem';

    export default {
        name: 'FilterBuilderSelect',
        mixins: [filterBuilderItem],
        props: {
            // [{ value, label }]
            options: { type: Array, default: () => [] },
            multiple: { type: Boolean, default: false },
            filterable: { type: Boolean, default: true },
            clearable: { type: Boolean, default: false },
            placeholder: { type: String, default: 'Selecione' },
        },
        methods: {
            getEmptyValue() {
                return this.multiple ? [] : null;
            },
        },
        components: {
            FilterBuilderRow,
            [Select.name]: Select,
            [Option.name]: Option,
        },
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/FilterBuilder/FilterBuilderSelect.vue